<template>
  <el-card class="filter-card" size="small">
    <el-collapse-transition>
      <div>
        <el-form 
          :model="filterForm" 
          class="filter-form-compact"
          size="mini"
          label-width="70px">
          
          <!-- 基本信息组 -->
          <div class="filter-row-compact">
            <div class="filter-items">
              <el-form-item label="单号" class="compact-item-inline">
                <el-input v-model="filterForm.sn" placeholder="单号" size="mini" clearable style="width: 115px"></el-input>
              </el-form-item>
              <el-form-item label="票号" class="compact-item-inline">
                <el-input v-model="filterForm.ticket_sn" placeholder="票号" size="mini" clearable style="width: 115px"></el-input>
              </el-form-item>
              <el-form-item label="电话" class="compact-item-inline">
                <el-input v-model="filterForm.tel" placeholder="电话" size="mini" clearable style="width: 115px"></el-input>
              </el-form-item>
              <el-form-item label="邮箱" class="compact-item-inline">
                <el-input v-model="filterForm.mail" placeholder="邮箱" size="mini" clearable style="width: 115px"></el-input>
              </el-form-item>
              <el-form-item label="微信" class="compact-item-inline">
                <el-input v-model="filterForm.wx_num" placeholder="微信" size="mini" clearable style="width: 115px"></el-input>
              </el-form-item>
              <el-form-item label="临近日" class="compact-item-inline">
                <el-input v-model="filterForm.near_day"  type="number" size="mini" clearable style="width: 115px"></el-input>
              </el-form-item>
            </div>
          </div>

          <el-form-item label="订单状态" class="compact-item-inline status-radio-group">
            <el-radio-group v-model="filterForm.status" size="mini">
              <el-radio-button
                v-for="option in filterOptions.status_options"
                :key="option.value" 
                :label="option.value"
                class="status-radio-item">
                <span>{{ option.label }}
                  <span v-if="option.num > 0" class="num-badge">{{ option.num }}</span>
                </span>
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="退款" class="compact-item-inline status-radio-group">
            <el-radio-group v-model="filterForm.back_status" size="mini">
              <el-radio-button
                v-for="option in filterOptions.back_status_options"
                :key="option.value" 
                :label="option.value"
                class="status-radio-item">
                <span>{{ option.label }}
                  <span v-if="option.num > 0" class="num-badge">{{ option.num }}</span>
                </span>
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
                 
          <!-- 状态信息组 -->
          <div class="filter-row-compact">
            <div class="filter-items">
              <el-form-item label="加急" class="compact-item-inline">
                <el-select v-model="filterForm.is_urgent" placeholder="加急" size="mini" clearable style="width: 80px">
                  <el-option 
                     v-for="(text, value) in filterOptions.is_urgent_options" 
                     :key="value" 
                     :label="text" 
                     :value="value">
                   </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>

          <!-- 其他信息组 -->
          <div class="filter-row-compact">
            <div class="filter-items">
              <el-form-item label="支付方式" class="compact-item-inline">
                <el-select v-model="filterForm.pay_type" placeholder="支付方式" size="mini" clearable style="width: 95px">
                  <el-option 
                     v-for="(text, value) in filterOptions.pay_type_options" 
                     :key="value" 
                     :label="text" 
                     :value="value">
                   </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单来源" class="compact-item-inline">
                <el-select v-model="filterForm.source" placeholder="订单来源" size="mini" clearable style="width: 95px">
                  <el-option 
                     v-for="(text, value) in filterOptions.source_options" 
                     :key="value" 
                     :label="text" 
                     :value="value">
                   </el-option>
                </el-select>
              </el-form-item>
               
              <el-form-item label="退款时间" class="compact-item-inline">
                <el-date-picker
                  v-model="filterForm.req_back_time"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始"
                  end-placeholder="结束"
                  size="mini"
                  style="width: 190px">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="compact-item-inline">
                <el-button-group size="mini">
                  <el-button 
                    type="primary" 
                    @click="handleFilter" 
                    :loading="loading"
                    :disabled="loading"
                    icon="el-icon-search">筛选</el-button>
                  <el-button 
                    @click="resetFilter" 
                    :disabled="loading"
                    icon="el-icon-refresh">重置</el-button>
                </el-button-group>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </el-collapse-transition>
  </el-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderFilter',
  data() {
    return {
      loading: false,
      filterForm: {
        sn: '',
        ticket_sn: '',
        tel: '',
        mail: '',
        wx_num: '',
        near_day: null,
        status: '',
        back_status: '',
        is_urgent: '',
        req_back_time: [],
        pay_type: '',
        source: ''
      },
      filterOptions: {
        status_options: {},
        back_status_options: {},
        pay_type_options: {},
        source_options: {},
        is_urgent_options: {}
      }
    }
  },
  mounted() {
    this.getFilterOptions()
  },
  methods: {
    // 获取筛选选项数据
    async getFilterOptions() {
      try {
        const response = await axios.get(this.base_url + '/order_server/get_order_filter_info')
        console.log('response', response)
        if (response.status === 200) {
          this.filterOptions = response.data.data
        } else {
          this.$message.error('获取筛选选项失败')
        }
      } catch (error) {
        console.error('获取筛选选项失败:', error)
        this.$message.error('获取筛选选项失败')
      }
    },
    
    // 构建筛选参数
    buildFilterParams() {
      const params = {}
      const form = this.filterForm
      
      if (form.sn) params.order_sn = form.sn
      if (form.ticket_sn) params.ticket_sn = form.ticket_sn
      if (form.tel) params.tel = form.tel
      if (form.mail) params.mail = form.mail
      if (form.wx_num) params.wx_num = form.wx_num
      if (form.status !== '') params.status = form.status
      if (form.back_status !== '') params.back_status = form.back_status
      if (form.is_urgent !== '') params.is_urgent = form.is_urgent
      if (form.pay_type !== '') params.pay_type = form.pay_type
      if (form.source !== '') params.source = form.source
      if (form.near_day !== null && form.near_day !== undefined) params.near_day = form.near_day.toString()
      
      // 处理退款时间范围
      if (form.req_back_time && form.req_back_time.length === 2) {
        params.req_back_start_date = this.formatDate(form.req_back_time[0])
        params.req_back_end_date = this.formatDate(form.req_back_time[1])
      }
      
      return params
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    handleFilter() {
      this.loading = true
      const params = this.buildFilterParams()
      this.$emit('filter', params)
    },
    
    // 重置loading状态（供父组件调用）
    resetLoading() {
      this.loading = false
    },
    
    resetFilter() {
      this.filterForm = {
        sn: '',
        ticket_sn: '',
        tel: '',
        mail: '',
        wx_num: '',
        near_day: null,
        status: '',
        back_status: '',
        is_urgent: '',
        req_back_time: [],
        pay_type: '',
        source: ''
      }
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
// 筛选卡片
.filter-card {
  margin-bottom: 15px;
  
  .el-card__header {
    padding: 10px 15px;
    font-size: 14px;
  }
  
  .el-card__body {
    padding: 10px 15px;
  }
}

// 筛选表单
.filter-form-compact {
  margin: 0;
}

.filter-row-compact {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  min-height: 30px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.filter-items {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  flex: 1;
}

// 紧凑表单项
.compact-item {
  margin-bottom: 0;
  margin-right: 10px;
  
  .el-form-item__label {
    padding: 0 6px 0 0;
    font-size: 12px;
    line-height: 26px;
    color: #606266;
  }
  
  .el-form-item__content {
    line-height: 26px;
  }
  
  .el-form-item {
    margin-bottom: 0;
    margin-right: 0;
  }
  
  // 统一输入框样式
  .el-input--mini .el-input__inner,
  .el-select--mini .el-input__inner {
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    padding: 0 8px;
    border-radius: 3px;
  }
  
  .el-date-editor--mini {
    height: 26px;
    line-height: 26px;
    font-size: 12px;
  }
  
  .el-input-number--mini {
    height: 26px;
    line-height: 26px;
    
    .el-input-number__increase,
    .el-input-number__decrease {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
  }
}

.compact-item-inline {
  margin-bottom: 0;
  margin-right: 0;
}

// 状态单选按钮组样式
.status-radio-group {
  .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
}

.num-badge {
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 2px;
  background: #f00;
  color: #fff;
}
</style>